export interface ColorInputProps {
  color: string;
  setColor: (value: string) => void;
  textValue: string;
  setTextValue: (value: string) => void;
  currentRef: any;
  label: string;
  opacity?: number;
  setOpacity?: (value: number) => void;
  showOpacity?: boolean;
  infoTooltipKey?: string;
  inputPlaceholder?: string;
}

export function rgbToHex(rgb: string): string | null {
  const regex = /^rgb\s*\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/i;
  const result = regex.exec(rgb);
  if (!result) return null;
  const [r, g, b] = result.slice(1).map((v) => Math.min(255, +v));
  return (
    '#' +
    [r, g, b]
      .map((x) => x.toString(16).padStart(2, '0'))
      .join('')
      .toUpperCase()
  );
}

export function isValidHex(hex: string) {
  return /^#([0-9A-F]{6}|[0-9A-F]{3})$/i.test(hex);
}

export function isValidRgba(rgba: string) {
  const regex =
    /^rgba\s*\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(0|1|0\.\d+)\s*\)$/i;
  return regex.test(rgba);
}

export function hexToRgba(hex: string, opacity: number = 1): string {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  if (!result) return hex;

  const r = parseInt(result[1], 16);
  const g = parseInt(result[2], 16);
  const b = parseInt(result[3], 16);

  return `rgba(${r}, ${g}, ${b}, ${opacity})`;
}

export function rgbaToHex(
  rgba: string
): { hex: string; opacity: number } | null {
  const regex =
    /^rgba\s*\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(0|1|0\.\d+)\s*\)$/i;
  const result = regex.exec(rgba);
  if (!result) return null;

  const [, r, g, b, a] = result;
  const hex =
    '#' +
    [r, g, b]
      .map((x) => parseInt(x).toString(16).padStart(2, '0'))
      .join('')
      .toUpperCase();

  return { hex, opacity: parseFloat(a) };
}

export function extractOpacityFromRgba(rgba: string): number {
  const regex =
    /^rgba\s*\(\s*\d{1,3}\s*,\s*\d{1,3}\s*,\s*\d{1,3}\s*,\s*(0|1|0\.\d+)\s*\)$/i;
  const result = regex.exec(rgba);
  return result ? parseFloat(result[1]) : 1;
}
